export const otherViewTypes = [
  { id: 0, type: 'listView', nameKey: 'HAMBURGER_LIST_VIEW' },
  { id: 1, type: 'tileView', nameKey: 'HAMBURGER_TILE_VIEW' },
  { id: 2, type: 'cubbyManager', nameKey: 'HAMBURGER_CUBBY_MANAGER' },
  {
    id: 3,
    type: 'orderStatusManger',
    nameKey: 'HAMBURGER_ORDER_STATUS_MANAGER',
  },
];

export const otherModeTypes = [
  { id: 0, type: 'DEFAULT', nameKey: 'HAMBURGER_GENERAL_MODE' },
  { id: 1, type: 'ON_PREMISE', nameKey: 'HAMBURGER_ONPREMISE_MODE' },
  { id: 2, type: 'OFF_PREMISE', nameKey: 'HAMBURGER_OFFPREMISE_MODE' },
  { id: 3, type: 'TABLE_DELIVERY', nameKey: 'HAMBURGER_TABLE_DELIVERY' },
];

export const hamburgerOptions = [
  { nameKey: 'HAMBURGER_PREAUTH', value: 'preAuth' },
  { nameKey: 'HAMBURGER_FUTURE_ORDERS', value: 'futureOrders' },
  { nameKey: 'HAMBURGER_BULK_TEXT_TO_PAY', value: 'bulkTextPay' },
  { nameKey: 'HAMBURGER_OUT_OF_STOCK', value: 'outOfStock' },
  { nameKey: 'HAMBURGER_STORE_PRODUCTION', value: 'storeProduction' },
  { nameKey: 'HAMBURGER_TABLE_MERGE', value: 'tableMerge' },
  { nameKey: 'HAMBURGER_ASSIGN_EMPLOYEE', value: 'assignEmployee' },
  { nameKey: 'HAMBURGER_SENSORS', value: 'sensor' },
  { nameKey: 'HAMBURGER_ABOUT', value: 'about' },
];

export default {
  otherViewTypes,
  otherModeTypes,
  hamburgerOptions,
};
